import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GrDocumentConfig } from 'react-icons/gr';
import { LuLayoutDashboard } from 'react-icons/lu';
import { TbFileInvoice, TbUserScreen } from 'react-icons/tb';
import { FiTv } from 'react-icons/fi';
import { MdOutlineSubscriptions, MdInstallDesktop, MdAddCard } from 'react-icons/md';
import { HiOutlineNewspaper } from 'react-icons/hi';
import logo from '../assets/img/logoAsset 2flag-rigth.svg';

const SidebarMenu = ({ isOpen, toggleDrawer }) => {
  const location = useLocation();

  const closeDrawer = () => {
    if (typeof toggleDrawer === 'function') toggleDrawer();
  };

  const navigationItems = [
    { label: 'Dashboard', to: '/dashboard', icon: LuLayoutDashboard },
    { label: 'Facturación', to: '/orders', icon: TbFileInvoice },
    { label: 'Servicios', to: '/servicios', icon: MdOutlineSubscriptions },
    { label: 'Suscripciones', to: '/subscriptions', icon: FiTv },
    { label: 'Instaladores', to: '/downloads', icon: MdInstallDesktop },
    { label: 'Suscriptores', to: '/clientes', icon: TbUserScreen },
    { label: 'Créditos', to: '/credits', icon: MdAddCard },
    { label: 'Blog', to: '/blog', icon: HiOutlineNewspaper }, // ✅ Nueva ruta
  ];

  const activeStyle = 'bg-[oklch(93.2%_0.032_255.585)] text-gray-900';

  return (
    <>
      {/* Sidebar fijo (desktop) */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="flex flex-col w-64 bg-white border-r border-gray-200">
          {/* Logo */}
          <div className="flex items-center px-4 h-16 border-b border-gray-100">
            <img src={logo} alt="Logo" className="h-8" />
          </div>

          {/* Navegación */}
          <div className="flex flex-col flex-1 overflow-y-auto px-2 py-4 space-y-1">
            {navigationItems.map(({ label, to, icon: Icon }) => {
              const isActive = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  onClick={closeDrawer}
                  className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium 
                    ${isActive ? activeStyle : 'text-gray-700 hover:bg-gray-100'}`}
                >
                  <Icon className="h-5 w-5" />
                  {label}
                </Link>
              );
            })}

            {/* Configuración */}
            <Link
              to="/settings"
              onClick={closeDrawer}
              className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100"
            >
              <GrDocumentConfig className="h-5 w-5" />
              Configuración
            </Link>
          </div>

          {/* Footer limpio */}
          <div className="mt-auto text-center text-[11px] text-gray-500 py-3">
            HOY VEMOS | {new Date().getFullYear()}
          </div>
        </div>
      </div>

      {/* Sidebar móvil (drawer) */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out lg:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex h-full flex-col">
          {/* Header móvil */}
          <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200">
            <img src={logo} alt="Logo" className="h-8" />
            <button onClick={closeDrawer} className="text-gray-500 hover:text-gray-700">✕</button>
          </div>

          {/* Navegación móvil */}
          <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
            {navigationItems.map(({ label, to, icon: Icon }) => {
              const isActive = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  onClick={closeDrawer}
                  className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium 
                    ${isActive ? activeStyle : 'text-gray-700 hover:bg-gray-100'}`}
                >
                  <Icon className="h-5 w-5" />
                  {label}
                </Link>
              );
            })}

            <Link
              to="/settings"
              onClick={closeDrawer}
              className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100"
            >
              <GrDocumentConfig className="h-5 w-5" />
              Configuración
            </Link>
          </nav>

          {/* Footer móvil limpio */}
          <div className="text-center text-[11px] text-gray-500 py-3">
            HOY VEMOS | {new Date().getFullYear()}
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm transition-opacity duration-300 ease-in-out lg:hidden"
          onClick={closeDrawer}
        />
      )}
    </>
  );
};

export default SidebarMenu;
